import { useQuery } from 'react-query';

import { api } from '../api';
import { TipoProd } from '../../types/TipoProd';

export interface ITransacaoParcela {
  dtHrTransacao: string;
  nsuTransacao: string;
  codAutTransacao: string;
  cartaoBIN: string;
  cartaoHolder: string;
  numSerieLeitor: string;
  situacao: 'A' | 'C';
  tipoProd: TipoProd;
  bandeira: string;
  descricao: string;
  qtdParcela: number;
  numParcela: number;
  vlTransacao: number;
  vlParcela: number;
  vlTxAdm: number;
  vlTxAnt: number;
  vlLiquido: number;
  dtPrevPgto: string;
  dtVenctoOriginal: string;
  estabFantasia: string;
  estabDocto: string;
}

interface IParams {
  docto: string;
  dtInicial: string;
  tipoPeriodo: string;
  dtFinal: string;
  bandeira: string;
  tipoProd: string;
  pagina: number;
  limite: number;
}

interface GetRelatorioPagamentoResult {
  transactions: ITransacaoParcela[];
  total: number;
}

export async function getRelatorioPagamento(
  params: IParams
): Promise<GetRelatorioPagamentoResult> {
  const { data } = await api.get('transactions/transacao-parcela', {
    params,
  });

  return { transactions: data, total: data.length };
}

export function useTransacaoParcela(params: IParams) {
  return useQuery(
    [
      'transacao-parcela',
      params.docto,
      params.dtInicial,
      params.tipoPeriodo,
      params.dtFinal,
      params.bandeira,
      params.tipoProd,
      params.pagina,
      params.limite,
    ],
    () => getRelatorioPagamento(params),
    {
      staleTime: Infinity,
      enabled:
        String(api.defaults.headers.common.authorization).length > 10 &&
        !!params.docto,
      retry: 2
    }
  );
}
